import React from 'react';
import { motion } from 'framer-motion';
import { trackPixelEvent } from '../utils/metaPixel';
export const CHECKOUT_URL = 'https://kit-biodescodificacion.impultienda.ar/checkout/biodescodificacion';
export const PRODUCT_NAME = 'KIT MAESTRO DE BIODESCODIFICACIÓN™';
export const PRICE = '$24.990 ARS';
export const PRICE_SHORT = '$24.990';
export const PRICE_FULL = '$45.990';
export const SUPPORT_EMAIL = 'soportelumenakasha@gmail.com';
export const WHATSAPP_LINK = 'https://wa.me/+5491234567890';
export const INSTAGRAM_LINK = 'https://instagram.com/lumen.akasha';

/** Evento de Meta Pixel disparado al ir al checkout. */
export function trackCheckoutClick(): void {
  trackPixelEvent('InitiateCheckout', {
    content_name: PRODUCT_NAME,
    content_type: 'product',
    value: 24990,
    currency: 'ARS'
  });
}
type SectionProps = {
  children: React.ReactNode;
  className?: string;
  id?: string;
  glow?: boolean;
};
export function Section({
  children,
  className = '',
  id = '',
  glow = false
}: SectionProps) {
  return <motion.section id={id} initial={{
    opacity: 0,
    y: 24
  }} whileInView={{
    opacity: 1,
    y: 0
  }} viewport={{
    once: true,
    margin: '-100px'
  }} transition={{
    duration: 0.3,
    ease: [0.23, 1, 0.32, 1]
  }} className={`relative mx-auto w-full max-w-7xl px-4 py-12 sm:px-6 md:py-20 lg:px-8 ${className}`} data-id="element-291" data-mp="39jhhkullb1wv">
      {glow && <div aria-hidden="true" className="pointer-events-none absolute inset-0 -z-10 overflow-hidden" data-id="element-292" data-mp="2qloosl4ok8d7">
          <div className="animate-aurora-1 absolute -top-16 left-[15%] h-80 w-80 rounded-full bg-brand-blueMist blur-[100px]" data-id="element-293" data-mp="2ltwv41q89miu" />
          <div className="animate-aurora-2 absolute -bottom-12 right-[12%] h-72 w-72 rounded-full bg-brand-goldLight/70 blur-[110px]" data-id="element-294" data-mp="2gw573ispekjx" />
        </div>}
      {children}
    </motion.section>;
}
type CTAButtonProps = {
  children: React.ReactNode;
  href?: string;
  className?: string;
  fullWidth?: boolean;
  variant?: 'blue' | 'gold';
};
export function CTAButton({
  children,
  href = '#comprar',
  className = '',
  fullWidth = false,
  variant = 'blue'
}: CTAButtonProps) {
  const colors = variant === 'gold' ? 'bg-brand-amber text-brand-blueDeep ring-1 ring-brand-goldDark/30 hover:bg-brand-gold' : 'bg-brand-blue text-brand-goldLight ring-1 ring-brand-gold/50 hover:bg-brand-blueDeep';
  return <motion.a href={href} onClick={() => {
    if (href === CHECKOUT_URL) trackCheckoutClick();
  }} whileHover={{
    scale: 1.02
  }} whileTap={{
    scale: 0.98
  }} transition={{
    duration: 0.14,
    ease: [0.23, 1, 0.32, 1]
  }} className={`inline-flex items-center justify-center rounded-full px-8 py-4 text-lg font-bold shadow-[0_10px_24px_rgba(8,32,60,.24)] transition-colors duration-150 ease-out focus:outline-none focus-visible:ring-4 focus-visible:ring-brand-amber/50 ${colors} ${fullWidth ? 'w-full' : ''} ${className}`} data-id="element-295" data-mp="1oayet4tow4or">
      {children}
    </motion.a>;
}